import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {InventoryFullConfirmPage} from './inventory-full-confirm';

const routes: Routes = [
  { path: '', component: InventoryFullConfirmPage },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InventoryFullConfirmPageRoutingModule {}
